import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getFromLocalStorage } from "../utils/local-storage";
import Soccer from "../../assets/svg/sports/Soccer.svg";
import { addToSlip, getBetslip, removeFromSlip } from "../utils/betslip";
import {
  betslipValidation,
  removePickedData,
  removeSelected,
  setMatchBetslip,
  // setMatchBetslipViax,
  setSelected,
} from "../../redux/bettingSlice";
import Notify from "../utils/Notify";
import BetslipMonitor from "./betslipMonitor";
import useWindowDimensions from "../header/Dimensions";
import { setState } from "../../redux/dataSlice";

export let externalChangeCallback = null;

export const onBetSlipChanged = (callback) => {
  externalChangeCallback = callback;

  const initialBetslip = getBetslip() || {};
  if (Object.keys(initialBetslip).length > 0) {
    const initialBetslipArray = Object.values(initialBetslip).map((bet) => ({
      externalEventId: bet.parent_match_id,
      externalMarketId: bet.sub_type_id,
      externalOutcomeId: bet.outcome_id,
      odd_value: bet.odd_value,
    }));

    const payload = {
      betslip: initialBetslipArray,
      combinedOddsValue: Object.values(initialBetslipArray ?? {})
        .reduce((previous, { odd_value }) => previous * odd_value, 1)
        .toFixed(2),
    };

    if (externalChangeCallback) {
      externalChangeCallback(payload);
    }
  }
};

let externalUpdateChangeCallback = () => {};

export const useUpdateChangeCallback = () => {
  const updateChangeCallback = useCallback((cb) => {
    externalUpdateChangeCallback = cb;
  }, []);

  return { updateChangeCallback, externalUpdateChangeCallback };
};
export const clear_rep = (str) => {
  return str.replace(/\s+/g, "");
};

export const handleButtonOnClick = (
  target,
  event,
  navigate,
  handleCombineOdds,
  dispatchRedux,
  settings,
  setBetSlipState,
  live
) => {
  if (target === "externalOutcome") {
    const { externalEvent, externalOutcome, externalMarket } = event;
    const eventId = externalEvent.id;
    const outcomeId = externalOutcome.id;
    const externalMarketId = externalMarket.id;

    // Ensure that event.externalOutcome.status.isActive is set to true
    externalOutcome.status.isActive = true;

    // Prepare attributes for bet slip
    const attributes = {
      parent_match_id: externalEvent.id,
      sub_type_id: externalMarket.id,
      odd_key: externalOutcome.name,
      odd_value: externalOutcome.odds,
      bet_type: externalEvent.isLive ? "1" : "0",
      odd_type: externalMarket.name,
      start_time: externalEvent.date,
      home_team: externalEvent.teams[0]?.name,
      away_team: externalEvent.teams[1]?.name,
      sport_name: externalEvent.sport.name,
      outcome_id: externalOutcome.id,
      market_active: externalMarket.status.isActive,
    };

    // Create a new bet object for viax
    const newBet = {
      externalEventId: eventId,
      externalMarketId: externalMarketId,
      externalOutcomeId: outcomeId,
      odd_value: attributes.odd_value,
    };

    // Local variable for viax data
    let viaxData = [];

    const generateSlip = (priority) => ({
      match_id: attributes.parent_match_id,
      parent_match_id: attributes.parent_match_id,
      special_bet_value: "",
      sub_type_id: attributes.sub_type_id,
      bet_pick: attributes.odd_key,
      start_time: attributes.start_time,
      odd_value: attributes.odd_value,
      home_team: attributes.home_team,
      away_team: attributes.away_team,
      bet_type: attributes.bet_type,
      odd_type: attributes.odd_type,
      outcome_id: attributes.outcome_id,
      sport_name: attributes.sport_name,
      live: 0,
      ucn: clear_rep(
        `${attributes.match_id ?? attributes.parent_match_id}${
          attributes.sub_type_id
        }${attributes.outcome_id}`
      ),
      market_active: attributes.market_active,
      position: 0,
      priority: priority,
    });

    const updateSlipState = (slip, newBet) => {
      const betslipData = { betslip_type: "betslip", data: addToSlip(slip) };

      // Push newBet to local viaxData array
      viaxData.push(newBet);

      // Dispatch for betslip but not viax
      dispatchRedux(
        setSelected(
          attributes.parent_match_id + "_selected",
          clear_rep(slip.ucn)
        )
      );

      dispatchRedux(
        betslipValidation({
          endpoint: "v2/betslip-validation",
          method: "POST",
          data: betslipData.data,
          payload: betslipData.data,
        })
      );

      // Update betslip state in Redux
      dispatchRedux(setMatchBetslip(betslipData));
    };

    setBetSlipState((prevState) => {
      const betExists = prevState.betslip.some(
        (bet) =>
          bet.externalEventId === newBet.externalEventId &&
          bet.externalMarketId === newBet.externalMarketId &&
          bet.externalOutcomeId === newBet.externalOutcomeId
      );

      const existingBetWithDifferentOutcome = prevState.betslip.find(
        (bet) =>
          bet.externalEventId === newBet.externalEventId &&
          bet.externalOutcomeId !== newBet.externalOutcomeId
      );

      let updatedBetSlipState;

      if (betExists) {
        // Remove existing bet
        const betslipOriginal = removeFromSlip(attributes.parent_match_id);

        dispatchRedux(removeSelected(attributes.parent_match_id + "_selected"));

        const betslip_data = {
          betslip_type: "betslip",
          data: betslipOriginal,
        };
        dispatchRedux(setMatchBetslip(betslip_data));

        updatedBetSlipState = {
          betslip: prevState.betslip.filter(
            (bet) =>
              !(
                bet.externalEventId === newBet.externalEventId &&
                bet.externalMarketId === newBet.externalMarketId &&
                bet.externalOutcomeId === newBet.externalOutcomeId
              )
          ),
          combinedOddsValue: handleCombineOdds(betslipOriginal),
        };
      } else if (existingBetWithDifferentOutcome) {
        // Update bet with different outcome
        const updatedBetslip = prevState.betslip.map((bet) =>
          bet.externalEventId === newBet.externalEventId &&
          bet.externalOutcomeId !== newBet.externalOutcomeId
            ? newBet
            : bet
        );

        updateSlipState(
          generateSlip(Object.keys(getBetslip() || {}).length + 1),
          newBet
        );

        updatedBetSlipState = {
          betslip: updatedBetslip,
          combinedOddsValue: handleCombineOdds(updatedBetslip),
        };
      } else {
        // Add new bet
        const betItems = getBetslip();
        const priority = Object.keys(betItems || {}).length + 1;

        const slip = generateSlip(priority);

        if (
          Object.keys(betItems || {}).length ===
          Number(settings?.sportsBookLimits?.multiBetMaxSelections)
        ) {
          dispatchRedux(removePickedData(" "));
          Notify({
            status: 401,
            message: "Maximum selections reached",
            token: "",
          });
        } else {
          addToSlip(slip);
          // addToSlipViax(newBet);
          updateSlipState(slip, newBet);
        }

        updatedBetSlipState = {
          betslip: [...prevState.betslip, newBet],
          combinedOddsValue: handleCombineOdds(betItems),
        };
      }

      if (externalChangeCallback) {
        // console.log("changeCallback slip passed data", updatedBetSlipState);
        externalChangeCallback(updatedBetSlipState);
      }

      return updatedBetSlipState;
    });
  }

  if (target === "externalEvent") {
    // console.log("live onclick", live);
    live
      ? navigate("/match/live/" + event?.externalEvent?.id)
      : navigate("/match/" + event?.externalEvent?.id);
  }
};

export const handleCombineOdds = (odds) => {
  let combined_odds = Object.values(odds ?? {}).reduce(
    (previous, { odd_value }) => {
      return previous * odd_value;
    },
    1
  );
  combined_odds = Number(combined_odds.toFixed(2));

  return combined_odds;
};

const RecommenderWidget = ({ live }) => {

  const userData = getFromLocalStorage("user") || ((state) => state.auth.user);
  const dispatchRedux = useDispatch();
  const [settings] = useState(getFromLocalStorage("settings"));
  const navigate = useNavigate();
  const [, setBetSlipState] = useState({
    betslip: [],
    combinedOddsValue: undefined,
  });

  // let changeCallback;

  const onTrack = (data) => {};

  const handleButtonOnClickWrapper = (target, event) => {
    console.log("handleButtonOnClickWrapper", target, event);
    // Pass the necessary arguments to the handleButtonOnClick function
    handleButtonOnClick(
      target,
      event,
      navigate, // navigate function
      handleCombineOdds, // handleCombineOdds function
      dispatchRedux, // dispatchRedux function
      settings, // settings object
      setBetSlipState, // setBetSlipState function
      live // live flag
    );
  };

  // // Effect to register SIR adapter and widget
  useEffect(() => {
    const widgetSelector = "#sr-widget-1";

    if (!window.SIR) return;

    const timeoutId = setTimeout(() => {
      window.SIR("addWidget", widgetSelector, "betRecommendation", {
        user: userData?.profile_id ?? null,
        onTrack,
        silent: false,
        count: 20,
        onItemClick: handleButtonOnClickWrapper,
        debug: true,
        categoryLayout: "tabs",
        branding: {
          sports: {
            icons: {
              1: Soccer,
            },
          },
        },
        filters: {
          time: {
            active: live ? ["live"] : ["not_started"],
          },
          sport: {
            hidden: false,
          },
        },
        sportsMapping: {
          172: "10",
          79: "1",
          80: "5",
          85: "2",
          82: "4",
          104: "20",
          97: "12",
        },
      });
    }, 10);

    // Cleanup
    return () => {
      console.log("sir removing recommender widget");
      if (window.SIR) {
        window.SIR("removeWidget", widgetSelector);
      }
      clearTimeout(timeoutId);
    };
  }, [userData?.profile_id, live]);

  return (
    <div className={`widgets page-display ${live ? "live-display" : ""}`}>
      <BetslipMonitor
        onBetslipChange={externalUpdateChangeCallback}
        handleCombineOdds={handleCombineOdds}
        live={live}
      />
      <div>
        <div id={"sr-widget-1"} className="sr-widget "></div>
      </div>
    </div>
  );
};

export default RecommenderWidget;
